/* eslint-disable multiline-ternary */
import React from 'react'
import { createStyles, makeStyles, Theme } from '@material-ui/core/styles'
import Card from '@material-ui/core/Card'
import CardContent from '@material-ui/core/CardContent'
import CardMedia from '@material-ui/core/CardMedia'
import Typography from '@material-ui/core/Typography'
import { useEditMode } from '../../providers/EditMode'
import clsx from 'clsx'
import { CircularProgress } from '@material-ui/core'

const useStyles = makeStyles((theme: Theme) =>
  createStyles({
    root: {
      position: 'fixed',
      right: theme.spacing(1),
      top: theme.spacing(1),
      display: 'flex',
      background: 'rgba(255, 255, 255, 1)',
      alignItems: 'center',
      justifyContent: 'center',
      borderRadius: 8,
      maxWidth: 296
    },
    details: {
      display: 'flex',
      flexDirection: 'column',
      justifyContent: 'center',
      alignItems: 'center'
    },
    content: {
      flex: '1 0 auto',
      fontSize: 9,
      padding: '3px 8px',
      '&.MuiCardContent-root:last-child': {
        paddingBottom: 3
      }
    },
    cover: {
      width: 60,
      height: 60,
      margin: theme.spacing(1),
      borderRadius: '50%'
    },
    editModeActive: {
      top: theme.spacing(1) + 60
    }
  })
)

interface DoctorCardProps {
  name: string
  hospital: string
  crm: string
  img?: string
  loading?: boolean
}

const DoctorCard: React.FC<DoctorCardProps> = ({
  name,
  hospital,
  crm,
  img,
  loading
}) => {
  const classes = useStyles()
  const { editMode } = useEditMode()

  return (
    <Card
      className={clsx(classes.root, {
        [classes.editModeActive]: editMode
      })}
    >
      {!loading ? (
        <>
          <CardMedia className={classes.cover} image={img} title={name} />
          <div className={classes.details}>
            <CardContent className={classes.content}>
              <Typography variant="subtitle1" color="primary">
                {hospital}
              </Typography>
              <Typography variant="subtitle1">{name}</Typography>
              <Typography variant="caption" color="textSecondary">
                CRM: {crm}
              </Typography>
            </CardContent>
          </div>
        </>
      ) : (
        <CircularProgress />
      )}
    </Card>
  )
}

export default DoctorCard
